<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      alert-type="error" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="createTargetGroup"
          @submit.prevent
        >
          <v-card
            max-width="800"
            elevation="0"
            rounded="xxl"
            color="background"
          > 
            <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
              {{ $t('createTargetGroupTitle') }}
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="name"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2"
                :placeholder="$t('createSpaceNamePlaceholder')"
                :rules="nameRules"
                data-testid="name-input"
              />
            </v-card-text>
          </v-card>
          <v-row>
            <v-col align="center">
              <FormFooter
                next-button-text="create"
                :loading="loading"
                cancel-button-link="/target-groups"
                @proceedSubmit="createTargetGroup"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import FormFooter  from '../../components/FormFooter'
import { ruleRequired, ruleValidMin2Max70Characters } from '../../rules/formRules.js';
import { createTargetGroup } from '../../api/targetGroupApi'
import AlertMessages  from '../../components/AlertMessages'
export default {
    components: {
        FormFooter,
        AlertMessages
    },
    data(){
        return{
            valid: true,
            name: '',
            checkbox: '',
            nameRules: ruleRequired('labelName').concat(ruleValidMin2Max70Characters('labelName')),
            alertMsg:'',
            alertValue:false,
            spaceId: window.$cookies.get('space_id'),
            loading: false
        }
    },
    methods: {
        async createTargetGroup(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading =true
                try {
                    let data = {
                        data: {
                            type: "target-groups", 
                            attributes: {
                                name: this.name.trim()
                            },
                            relationships: {
                                space: {
                                    data: {
                                        type: "spaces",
                                        id: "" + this.spaceId + ""
                                    }
                                }
                            }
                        }
                    };
                    var response = await createTargetGroup(data);
                    if(response){
                        if(response.status == 201) {
                            this.$router.push({name: 'TargetGroups', params: { successfullyCreatedTargetGroup: true}})
                        }
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if (e.response.status == 422 ){
                            if (e.response.data.errors[0].detail == "The name has already been taken.") {
                                this.alertMsg =  i18n.t('targetGroupExistMsg')
                                this.name=''
                            }else{
                                this.alertMsg =  i18n.t('serverError')
                            }
                        } else if (e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else{
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }
                }
                this.loading =false
            
                /*
                if(this.name == 'Test'){
                    this.alertMsg =  i18n.t('targetGroupExistMsg')
                    this.name=''
                }else{
                    this.$router.push({name: 'TargetGroup', params: {successfullyCreatedTargetGroup: true}})
                }*/
                
            }
            
        },
    }
}
</script>
